module.exports = __webpack_public_path__ + "img/logo-repias.968b5ebb.png";